import {
  AdvantagesSection,
  GeneralPaywallMeta,
  GuidesSection,
  JourneySection,
  ProgramOverviewSection,
  ProgramPaywallGeneralDataType,
  StoriesSection,
} from '@7chairs/types';

export interface PaywallMeta {
  generalData: GeneralPaywallMeta;
  storiesSection: StoriesSection;
  advantagesSection: AdvantagesSection;
  journeySection: JourneySection;
  guidesSection: GuidesSection;
  programPaywallGeneralData: ProgramPaywallGeneralDataType;
  programPaywallOverviewSection: ProgramOverviewSection;
  programPaywallAdvantagesSection: AdvantagesSection;
}

export enum PaywallMetaVariants {
  WeeklySessions = 'weekly-sessions',
}
